import { Route, Routes } from 'react-router-dom';
import './Profile.css';
import ProfileIndex from './ProfileIndex/ProfileIndex';
import { PROFILE_CHANGE_EMAIL_LINK, PROFILE_CHANGE_PASSWORD_LINK, PROFILE_COLLECTION_MAIN_LINK, PROFILE_EDIT_LINK, PROFILE_NOTIFICATIONS_LINK, PROFILE_ORDERS_MAIN_LINK, PROFILE_QR_LINK } from '../../assets/utils/constants';
import ProfileQR from './ProfileQR/ProfileQR';
import ProfileNotifications from './ProfileNotifications/ProfileNotifications';
import EditProfile from './EditProfile/EditProfile';
import EmailChange from './EditProfile/EmailChange/EmailChange';
import PasswordChange from './EditProfile/PasswordChange/PasswordChange';
import OrdersRouter from './Orders/OrdersRouter/OrdersRouter';
import CollectionRouter from './Collection/CollectionRouter/CollectionRouter';

function Profile() {
    return (
        <div className='profile'>
            <Routes>
                <Route index element={<ProfileIndex />} />
                <Route path={`${PROFILE_QR_LINK}`} element={<ProfileQR />} />
                <Route path={`${PROFILE_NOTIFICATIONS_LINK}`} element={<ProfileNotifications />} />
                <Route path={`${PROFILE_EDIT_LINK}`} element={<EditProfile />} />
                <Route path={`${PROFILE_CHANGE_EMAIL_LINK}`} element={<EmailChange />} />
                <Route path={`${PROFILE_CHANGE_PASSWORD_LINK}`} element={<PasswordChange />} />
                <Route path={`${PROFILE_COLLECTION_MAIN_LINK}/*`} element={<CollectionRouter />} />
                <Route path={`${PROFILE_ORDERS_MAIN_LINK}/*`} element={<OrdersRouter />} />
            </Routes>
        </div>
    );
}

export default Profile